export default __webpack_public_path__ + "static/media/bch.bf591955.png";